/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateOrUpdateMedicalSystemSetupDto } from './CreateOrUpdateMedicalSystemSetupDto';
import {
    instanceOfCreateOrUpdateMedicalSystemSetupDto,
    CreateOrUpdateMedicalSystemSetupDtoFromJSON,
    CreateOrUpdateMedicalSystemSetupDtoFromJSONTyped,
    CreateOrUpdateMedicalSystemSetupDtoToJSON,
} from './CreateOrUpdateMedicalSystemSetupDto';
import type { CreateOrUpdateMvTherapySystemSetupDto } from './CreateOrUpdateMvTherapySystemSetupDto';
import {
    instanceOfCreateOrUpdateMvTherapySystemSetupDto,
    CreateOrUpdateMvTherapySystemSetupDtoFromJSON,
    CreateOrUpdateMvTherapySystemSetupDtoFromJSONTyped,
    CreateOrUpdateMvTherapySystemSetupDtoToJSON,
} from './CreateOrUpdateMvTherapySystemSetupDto';

/**
 * @type CreateOrUpdateMedicalSystemSetupBaseDto
 * 
 * @export
 */
export type CreateOrUpdateMedicalSystemSetupBaseDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateMedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateOrUpdateMedicalSystemSetupDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateMvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateOrUpdateMvTherapySystemSetupDto;


export function CreateOrUpdateMedicalSystemSetupBaseDtoFromJSON(json: any): CreateOrUpdateMedicalSystemSetupBaseDto {
    return CreateOrUpdateMedicalSystemSetupBaseDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateMedicalSystemSetupBaseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateMedicalSystemSetupBaseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateMedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateOrUpdateMedicalSystemSetupDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateMedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateMvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateOrUpdateMvTherapySystemSetupDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateMvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared'};
        default:
            throw new Error(`No variant of CreateOrUpdateMedicalSystemSetupBaseDto exists with '$type=${json['$type']}'`);
    }
}

export function CreateOrUpdateMedicalSystemSetupBaseDtoToJSON(value?: CreateOrUpdateMedicalSystemSetupBaseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateMedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateOrUpdateMedicalSystemSetupDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateMvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateOrUpdateMvTherapySystemSetupDtoToJSON(value);
        default:
            throw new Error(`No variant of CreateOrUpdateMedicalSystemSetupBaseDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the CreateOrUpdateMedicalSystemSetupBaseDto interface.
 */
export function instanceOfCreateOrUpdateMedicalSystemSetupBaseDto(value: any): value is CreateOrUpdateMedicalSystemSetupBaseDto {
    if (instanceOfCreateOrUpdateMedicalSystemSetupDto(value)) return true;
    if (instanceOfCreateOrUpdateMvTherapySystemSetupDto(value)) return true;
    return false;
}

